module.exports = __webpack_public_path__ + "static/media/icon-commentbg.c2c0b8e7.svg";